import Axios from "../utils/axiosInstance";

export const GetLoggedInUserData = () => {
    return Axios.get("api/Messages/GetUserDetails", {});
};